export default __webpack_public_path__ + "static/media/exploded-view_labels.08fc01a0.png";